export default function reducer(state, action) {
  switch (action.type) {
    case 'NEXT_STEP':
      return { ...state, actualStep: state.actualStep + 1 };
    case 'BACK_STEP':
      return { ...state, actualStep: state.actualStep - 1 };
    case 'SET_IS_COMPLETE':
      const steps = state.listOfSteps;
      steps[state.actualStep - 1].isComplete = action.isComplete;

      return { ...state, listOfSteps: steps };
    default:
      throw new Error();
  }
}
